




































import ButtonStyle from "@/components/element/ButtonStyle.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

const ALERT_ATTEMPTS_IMAGE_PATH = "/peakengine/Content/Image/Security/alert_attempts.png";

@Component({
  components: {
    ButtonStyle,
  },
})
export default class ModalOBPassword extends Vue {
  @Prop({ type: Boolean, default: true })
  private showModal!: boolean;

  @Prop({ type: String, default: "" })
  private username!: string;

  private peakFileServer = process.env.VUE_APP_PeakFileServer || "";

  get alertAttemptsImageSrc(): string {
    return this.peakFileServer.replace(/\/?$/, "") + ALERT_ATTEMPTS_IMAGE_PATH;
  }

  get descriptionHtml(): string {
    const before = this.$t("Modal_OB_Password_Description_Before") as string;
    const phrase = this.$t("Modal_OB_Password_Forgot_Password_Phrase") as string;
    const after = this.$t("Modal_OB_Password_Description_After") as string;
    return `${before}<span class="font-weight-bold">"${phrase}"</span>${after}`;
  }

  get warningHtml(): string {
    const before = this.$t("Modal_OB_Password_Warning_Before") as string;
    const redPart = this.$t("Modal_OB_Password_Warning_Red") as string;
    return `${before}<span class="text-danger">${redPart}</span>`;
  }

  HideModal() {
    this.$emit("update:showModal", false);
  }

  HandleTryAgain() {
    this.HideModal();
  }

  HandleForgotPassword() {
    this.HideModal();
    const peakAccountBaseUrl = (process.env.VUE_APP_PeakAccount || "").replace(/\/?$/, "");
    window.open(`${peakAccountBaseUrl}/forgotPwd?a=${encodeURIComponent(this.username || "")}`, "_blank");
  }
}
